import React from 'react'
import UserSignup from '../../components/UserSignup/UserSignup'

function UserSignupPage() {
  return (
    <UserSignup></UserSignup>
  )
}

export default UserSignupPage